import React from 'react';
import { ProviderDocument, ProviderDocumentType } from '@uplift/api';
import { DocumentLayout } from './components';
import { CollaborativeAgreementUnsignedPreview } from './CollaborativeAgreementUnsignedPreview';
import { CollaborativeAgreementSignedPreview } from './CollaborativeAgreementSignedPreview';
import { CollaborativeAgreementCounterSignatureRequiredPreview } from './CollaborativeAgreementCounterSignatureRequiredPreview';
import { CollaborativeAgreementCounterSignedPreview } from './CollaborativeAgreementCounterSignedPreview';


export const DocumentPreview: React.FC<{
  document: ProviderDocument;
  setSelectedDocumentId: (documentId: string | null) => void;
}> = ({ document, setSelectedDocumentId }) => {
  switch (document.type) {
    case ProviderDocumentType.collaborativeAgreementUnsigned:
      return (
        <CollaborativeAgreementUnsignedPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.collaborativeAgreement:
      return (
        <CollaborativeAgreementSignedPreview document={document.document} />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSignatureRequired:
      return (
        <CollaborativeAgreementCounterSignatureRequiredPreview
          document={document.document}
          onSign={agreementId => setSelectedDocumentId(agreementId)}
        />
      );
    case ProviderDocumentType.collaborativeAgreementCounterSigned:
      return (
        <CollaborativeAgreementCounterSignedPreview document={document.document} />
      );
    default:
      return (
        <DocumentLayout
          title="Unknown document"
          subtitle=" "
        >
          Unknown document type
        </DocumentLayout>
      );
  }
};
